var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useState } from 'react';
import { Stack } from 'syf-component-library/ui/spacing';
import { VerticalCardLoader } from 'syf-component-library/ui/atoms';
import { useAccountSummary, useChangePaymentDueDateGet, useChangePaymentDueDatePut } from '../../../../const/syf-api-queries';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import SelectDueDate from '../../components/SelectDueDate';
import Disclaimer from '../../components/Disclaimer';
import Successful from '../../components/Successful';
import { ConfigContext } from '../../context';
import addOrdinalSuffix from '../../helpers/add-ordinal-suffix';
import { BodyContainer, ModalContentWrapper } from './subcomponents';
import { ChangePaymentDueDateScreen } from '../../typings';
import ChangePaymentDueDateErrors from './utils/ChangePaymentDueDateErrors';
import triggerChangePaymentDueDateAnalytics from '../../helpers/trigger-change-payment-due-date-analytics';
import { BUSINESS_ERROR_CODES } from '../../const/status-and-error-codes';
import { PAGE_NAME } from '../../const/analytics';
var ChangePaymentDueDateContent = function () {
    var _a;
    var _b = useContext(ConfigContext), config = _b.config, handleClose = _b.handleClose, selectedAccountId = _b.selectedAccountId;
    var _c = useState(), selectedDay = _c[0], setSelectedDay = _c[1];
    var _d = useState({}), errorDetails = _d[0], setErrorDetails = _d[1];
    var _e = useState(ChangePaymentDueDateScreen.INITIAL_SCREEN), currentScreen = _e[0], setCurrentScreen = _e[1];
    var changeScreen = function (screen) { return setCurrentScreen(screen); };
    var _f = useAccountSummary(selectedAccountId), accountSummaryData = _f.data, isAccountSummaryError = _f.isError, isAccountSummaryFetching = _f.isFetching, getSummaryErrorResponse = _f.error;
    var _g = useChangePaymentDueDateGet(selectedAccountId), dueDateGetData = _g.data, isGetFetching = _g.isFetching, isGetError = _g.isError, getErrorResponse = _g.error;
    var currentDueDay = dueDateGetData === null || dueDateGetData === void 0 ? void 0 : dueDateGetData.currentDueDay;
    var eligibleDueDays = dueDateGetData === null || dueDateGetData === void 0 ? void 0 : dueDateGetData.eligibleDueDays;
    var _h = useChangePaymentDueDatePut(config), putResponseData = _h.data, mutate = _h.mutate, isPutLoading = _h.isLoading, isPutError = _h.isError, putErrorResponse = _h.error;
    var date = (_a = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.billing) === null || _a === void 0 ? void 0 : _a.nextPaymentDate.split('-');
    var nextDueDay = (date === null || date === void 0 ? void 0 : date[2]) ? Number(date[2]) : undefined;
    var currentDueDate = currentDueDay !== null && currentDueDay !== void 0 ? currentDueDay : nextDueDay;
    var hasError = isGetError || isPutError || isAccountSummaryError;
    var showLoader = isGetFetching || isPutLoading || isAccountSummaryFetching;
    var hasEncounteredError = Boolean(Object.keys(errorDetails).length > 0 && (errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.hasError));
    var handleSelectDay = function (day) {
        if (eligibleDueDays === null || eligibleDueDays === void 0 ? void 0 : eligibleDueDays.some(function (eligibleDay) { return eligibleDay.eligibleDueDay === day; })) {
            if (selectedDay === day || currentDueDate === day)
                return;
            setSelectedDay(day);
        }
    };
    var handleClick = function () {
        if (selectedDay === undefined) {
            triggerChangePaymentDueDateAnalytics({
                pageName: PAGE_NAME.ERROR,
                errorMessage: 'Please select a new due date'
            });
            setCurrentScreen(ChangePaymentDueDateScreen.SELECT_DAY_ERROR_SCREEN);
            return;
        }
        var samplePayload = {
            'cipher.accountId': selectedAccountId,
            accountIdType: 'guid',
            newDueDay: selectedDay.toString()
        };
        mutate(samplePayload, {
            onSuccess: function () {
                triggerChangePaymentDueDateAnalytics({
                    pageName: PAGE_NAME.COMPLETE
                });
                changeScreen(ChangePaymentDueDateScreen.SUCCESSFUL_SCREEN);
            }
        });
    };
    var handleResponseError = useCallback(function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var responseError, parsedError, errorCode;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    responseError = error === null || error === void 0 ? void 0 : error.response;
                    if (!(error && responseError)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (responseError === null || responseError === void 0 ? void 0 : responseError.json())];
                case 1:
                    parsedError = _b.sent();
                    if ('businessErrors' in parsedError) {
                        errorCode = (_a = parsedError === null || parsedError === void 0 ? void 0 : parsedError.businessErrors) === null || _a === void 0 ? void 0 : _a[0].code;
                        triggerChangePaymentDueDateAnalytics({
                            pageName: PAGE_NAME.ERROR,
                            errorMessage: errorCode === BUSINESS_ERROR_CODES.DATE_ALREADY_CHANGED
                                ? 'You can change your due date once every 12 months'
                                : 'We cannot process your request for Change Due Date at this time.',
                            pageSubFunction: 'non eligible'
                        });
                        setErrorDetails({ hasError: true, errorCode: errorCode });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    // 4xx or 5xx error
                    triggerChangePaymentDueDateAnalytics({
                        pageName: PAGE_NAME.ERROR,
                        errorMessage: 'We’re having trouble retrieving your information.',
                        pageSubFunction: 'technical'
                    });
                    setErrorDetails({ hasError: true, errorCode: '' });
                    _b.label = 3;
                case 3:
                    changeScreen(ChangePaymentDueDateScreen.EXECUTION_ERROR_SCREEN);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        if (hasError) {
            handleResponseError((getErrorResponse ||
                putErrorResponse ||
                getSummaryErrorResponse));
        }
        else {
            setErrorDetails({ hasError: false, errorCode: '' });
        }
    }, [
        getErrorResponse,
        getSummaryErrorResponse,
        handleResponseError,
        hasError,
        putErrorResponse
    ]);
    useEffect(function () {
        // cleanup
        return function () {
            handleClose();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (showLoader) {
        return (_jsx("div", __assign({ "data-testid": "skeleton-loader" }, { children: _jsx(VerticalCardLoader, {}) })));
    }
    var showSelectDueDate = !hasError &&
        !hasEncounteredError &&
        !showLoader &&
        currentScreen !== ChangePaymentDueDateScreen.EXECUTION_ERROR_SCREEN &&
        [
            ChangePaymentDueDateScreen.INITIAL_SCREEN,
            ChangePaymentDueDateScreen.SELECT_DAY_ERROR_SCREEN
        ].includes(currentScreen);
    return (_jsxs(ModalContentWrapper, __assign({ id: "modal-content-wrapper" }, { children: [_jsx(BodyContainer, __assign({ "data-cy": "change-payment-due-date-container" }, { children: hasEncounteredError || hasError ? (_jsx(ChangePaymentDueDateErrors, { errorCode: errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.errorCode })) : (_jsxs(_Fragment, { children: [showSelectDueDate && (_jsxs(_Fragment, { children: [_jsx(Header, { date: addOrdinalSuffix(currentDueDate), currentScreen: currentScreen }), _jsx(SelectDueDate, { currentDueDay: currentDueDate, eligibleDueDays: eligibleDueDays, handleSelectDay: handleSelectDay, selectedDay: selectedDay }), _jsx(Stack, { size: "base" }), _jsx(Disclaimer, {})] })), currentScreen === ChangePaymentDueDateScreen.SUCCESSFUL_SCREEN && (_jsx(Successful, { currentDueDay: currentDueDate, selectedDay: selectedDay, isPromoExtended: Boolean(putResponseData === null || putResponseData === void 0 ? void 0 : putResponseData.promosExtended) }))] })) })), _jsx(Footer, { handleClose: handleClose, handleClick: handleClick, currentScreen: currentScreen, selectedDay: selectedDay })] })));
};
export default ChangePaymentDueDateContent;
